import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=f3fc9e22&scoped=true&"
import script from "../assets/js/exam.js?vue&type=script&lang=js&"
export * from "../assets/js/exam.js?vue&type=script&lang=js&"
import style0 from "../assets/css/exam.css?vue&type=style&index=0&id=f3fc9e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fc9e22",
  null
  
)

export default component.exports